import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableMandub from "./ScroollTableMandub";
import FillDetailMandub from "./FillDetailMandub";
import FooterOfMandub from "./FooterOfMandub";
const AllMandub = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailMandub />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableMandub />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 col-12">
            <FooterOfMandub />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllMandub;
